// extracted by mini-css-extract-plugin
var _1 = "error__ZDtbx";
var _2 = "has-error__TowkE";
var _3 = "label__bnUZm";
var _4 = "text__uzlzv";
var _5 = "tooltip__87M2r";
export { _1 as "error", _2 as "hasError", _3 as "label", _4 as "text", _5 as "tooltip" }
